module.exports = __webpack_public_path__ + "static/tags-based-configuration_4-6417dc013144b26630b2c6656fe4cbfc.png";